import {saveAs} from 'file-saver';
import {Document, Packer, Paragraph, TextRun, HeadingLevel, Header, Footer} from "docx";

import pdfMake from 'pdfmake'

import Utils from '@/providers/Utils'

export default {

    // -------- tool options ----------

    toolName: 'supportPlan',
    label: 'Classroom Plan Writer',
    logo: 'Classroom-plan-writer-logo.png',

    getDefaultData() {
        return {
            docTitle: 'Untitled',
            currentStep: 1,
            strategies: [],
            fontFace: 'sans',
            fontSize: 'small',
            showAnnotations: true,
            showLinks: false
        }
    },

    steps: [
        {id: 1, title: 'Select Strategies'},
    ],

    exportOptions: [
        {name: 'showAnnotations', type: 'bool', value: true, label: 'Include Citations'},
        {name: 'showLinks', type: 'bool', value: true, label: 'Include Links'},
        {name: 'introText', type: 'textarea', value: '', label: 'Introductory Text'},
    ],

    // define which download methods are supported - see ToolContainerPreviewToolbar::inject
    provide: function () {
        return {
            downloadDocFile: this.doDownloadDocFile,
            downloadPdfFile: this.doDownloadPdfFile,
            exportToGoogleForms: null,
        }
    },

    methods: {
        getAnnotation(id) {
            const annotation = _.find(this.config.supportPlan.annotations, (a) => a.id == id)
            if (annotation) {
                return annotation
            } else {
                return {title: 'DELETED ANNOTATION'} // shouldn't happen
            }
        },

        doDownloadDocFile() {
            const docx = new Document()

            const section = this.getDocxBaseSection()

            if (this.doc.title != this.$api.DEFAULT_DOC_TITLE) {
                section.children = [
                    this.createDocxTitle(this.doc.title)
                ]
            }

            if (this.docData.introText) {
                const paragraphs = this.splitTextByLineBreaks(this.docData.introText + '\n')
                _.each(paragraphs, (p) => {
                    section.children.push(this.createDocxParagraph(p))
                })
            }

            _.each(this.docData.strategies, (s) => {
                section.children.push(this.createDocxHeader(`${s.categoryTitle} » ${s.subjectTitle} » \n${s.strategy.title}`))
                const paragraphs = this.splitTextByLineBreaks(s.strategy.text)
                _.each(paragraphs, (p) => {
                    section.children.push(this.createDocxParagraph(p))
                })

                if (s.notes) {
                    const paragraphs = this.splitTextByLineBreaks('NOTES:\n' + s.notes + '\n')
                    _.each(paragraphs, (p) => {
                        section.children.push(this.createDocxParagraph(p, {italics: true}))
                    })
                }

                if (this.docData.showAnnotations) {
                    _.each(s.strategy.annotations, (aid) => {
                        section.children.push(this.createDocxParagraph(this.getAnnotation(aid).text))
                    })
                }

                if (this.docData.showLinks) {
                    section.children.push(this.createDocxParagraph(s.strategy.links))
                }
            })

            docx.addSection(section)

            Packer.toBlob(docx).then((blob) => {
                saveAs(blob, `${this.doc.title}.docx`)
            });
        },

        doDownloadPdfFile() {
            this.initPdfMakeFonts() // see ExportMixin
            const dd = this.getPdfBaseDocDefinition()

            if (this.doc.title != this.$api.DEFAULT_DOC_TITLE) {
                dd.content.push({
                    text: this.doc.title,
                    style: 'title'
                })
            }

            if (this.docData.introText) {
                dd.content.push({
                    text: this.docData.introText,
                    style: 'paragraph'
                })
            }

            _.each(this.docData.strategies, (s) => {
                dd.content.push({
                    text: `${s.categoryTitle} » ${s.subjectTitle} » \n${s.strategy.title}`,
                    style: 'header'
                })
                dd.content.push({
                    text: s.strategy.text,
                    style: 'paragraph'
                })

                if (s.notes) {
                    dd.content.push({
                        text: 'NOTES: ' + s.notes,
                        style: 'paragraphItalic'
                    })
                }

                if (this.docData.showAnnotations) {
                    _.each(s.strategy.annotations, (aid) => {
                        dd.content.push({
                            text: this.getAnnotation(aid).text,
                            style: 'paragraph'
                        })
                    })
                }

                if (this.docData.showLinks) {
                    dd.content.push({
                        text: s.strategy.links,
                        style: 'paragraph'
                    })
                }
            })

            pdfMake.createPdf(dd).download(`${this.doc.title}.pdf`)
        },

    },
}
